import { render, staticRenderFns } from "./upload-safeimg.vue?vue&type=template&id=64718bc7&scoped=true&"
import script from "./upload-safeimg.vue?vue&type=script&lang=js&"
export * from "./upload-safeimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64718bc7",
  null
  
)

export default component.exports